<template>
  <div id="app">
    <!-- 头部+侧边栏star -->
    <div class="Hearder">
      <Header></Header>
    </div>
    <!-- <div class="NavLeft" :class="{ 'active2': isActive2 }">
      <main-tab-bar></main-tab-bar>
    </div> -->
    <!-- 头部+侧边栏end -->

    <!-- 内容区域star -->
    <div class="Content" :class="{ 'active': isActive, 'active2': isActive2 }">
      <router-view/>
    </div>
    <!-- 内容区域end -->


    <!-- 进度条star -->
    <div class="ProgressBar" :style="{ width: progress + '%' }"></div>
    <!-- 进度条end -->
  </div>
</template>

<script>
  import mainTabBar from "@c/common/tabbar/mainTabBar";
  import Header from "@c/common/tabbar/header";

  export default {
    name: "App",
    components: {
      mainTabBar,Header
    },
    data(){
      return {
        show : false,
        isLogin : this.$store.getters.isLogin,
        isActive: false,
        isActive2: false,
        progress: 0 // 进度条初始值
      }
    },
    mounted() {
      this.isActive = this.$route.meta.addClass
      this.isActive2 = this.$route.meta.addClass2
    },
    watch: {
      '$route'(to, from) {
        this.isActive = to.meta.addClass
        this.isActive2 = to.meta.addClass2
      },
      // 监听路由变化
      $route(to, from) {
        const toProgress = to.meta.progressChange || 0
        this.progress = toProgress
      }
    }
  }
</script>

<style>
  @import "assets/css/base.css";
  @import "assets/ailogo/css/main.css";
  @import "assets/ailogo/css/iconfont.css";
  @import "assets/ailogo/css/fonts.css";
  @import "assets/ailogo/css/loaders.css";
</style>
